import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Image, List, Stack } from '@chakra-ui/react';
import { Feature } from '@shinetools/pricing-plan-library';

import Button from 'components/_core/Button';
import SunshineModal, {
  SunshineModalProps,
} from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';
import UpgradablePlanBadge from 'components/UpgradablePlanBadge';
import { logEvent } from 'features/Analytics/analytics';
import * as upgradeRoutes from 'features/Upgrade/routes';

import logoUploadBanner from '../../assets/logo-upload-banner.png';
import UpsellModalListItem from './components/UpsellModalListItem';
import locales from './locales';

interface UpsellModalProps extends Omit<SunshineModalProps, 'children'> {
  onClose: () => void;
}

const UpsellModal: FC<UpsellModalProps> = (props) => {
  const onChangePlanClick = () => {
    logEvent({ name: 'Logo Upsell Modal Change Plan Clicked' });
  };

  return (
    <SunshineModal {...props}>
      <SunshineModal.Header />

      <Image alt="" role="presentation" src={logoUploadBanner} />

      <SunshineModal.Body>
        <Stack alignItems="flex-start" spacing="space-16">
          <UpgradablePlanBadge feature={Feature.PersonalizedLogo} />
          <SunshineModal.Title>{locales.title}</SunshineModal.Title>
          <Text>{locales.subTitle}</Text>
          <List display="grid" rowGap="space-16">
            {[
              locales.moves,
              locales.limits,
              locales.insurances,
              locales.accounting,
            ].map((locale) => (
              <UpsellModalListItem key={locale}>{locale}</UpsellModalListItem>
            ))}
          </List>
        </Stack>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button
          as={Link}
          icon="arrow-right"
          onClick={onChangePlanClick}
          to={upgradeRoutes.choice}
        >
          {locales.changePlan}
        </Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default UpsellModal;
